"use client";
"use strict";

var _taggedTemplateLiteral = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");
var _objectSpread = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread2");
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject0, _templateObject1, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14;
var se = Object.create;
var k = Object.defineProperty;
var ae = Object.getOwnPropertyDescriptor;
var ie = Object.getOwnPropertyNames;
var ne = Object.getPrototypeOf,
  ce = Object.prototype.hasOwnProperty;
var pe = (e, t) => {
    for (var o in t) k(e, o, {
      get: t[o],
      enumerable: !0
    });
  },
  G = (e, t, o, s) => {
    if (t && typeof t == "object" || typeof t == "function") for (let a of ie(t)) !ce.call(e, a) && a !== o && k(e, a, {
      get: () => t[a],
      enumerable: !(s = ae(t, a)) || s.enumerable
    });
    return e;
  };
var j = (e, t, o) => (o = e != null ? se(ne(e)) : {}, G(t || !e || !e.__esModule ? k(o, "default", {
    value: e,
    enumerable: !0
  }) : o, e)),
  de = e => G(k({}, "__esModule", {
    value: !0
  }), e);
var Ue = {};
pe(Ue, {
  CheckmarkIcon: () => U,
  ErrorIcon: () => C,
  LoaderIcon: () => L,
  ToastBar: () => N,
  ToastIcon: () => $,
  Toaster: () => oe,
  default: () => Le,
  resolveValue: () => g,
  toast: () => i,
  useToaster: () => M,
  useToasterStore: () => w
});
module.exports = de(Ue);
var me = e => typeof e == "function",
  g = (e, t) => me(e) ? e(t) : e;
var J = (() => {
    let e = 0;
    return () => (++e).toString();
  })(),
  _ = (() => {
    let e;
    return () => {
      if (e === void 0 && typeof window < "u") {
        let t = matchMedia("(prefers-reduced-motion: reduce)");
        e = !t || t.matches;
      }
      return e;
    };
  })();
var A = require("react");
var le = 20,
  Y = "default";
var K = (e, t) => {
    let {
      toastLimit: o
    } = e.settings;
    switch (t.type) {
      case 0:
        return _objectSpread(_objectSpread({}, e), {}, {
          toasts: [t.toast, ...e.toasts].slice(0, o)
        });
      case 1:
        return _objectSpread(_objectSpread({}, e), {}, {
          toasts: e.toasts.map(r => r.id === t.toast.id ? _objectSpread(_objectSpread({}, r), t.toast) : r)
        });
      case 2:
        let {
          toast: s
        } = t;
        return K(e, {
          type: e.toasts.find(r => r.id === s.id) ? 1 : 0,
          toast: s
        });
      case 3:
        let {
          toastId: a
        } = t;
        return _objectSpread(_objectSpread({}, e), {}, {
          toasts: e.toasts.map(r => r.id === a || a === void 0 ? _objectSpread(_objectSpread({}, r), {}, {
            dismissed: !0,
            visible: !1
          }) : r)
        });
      case 4:
        return t.toastId === void 0 ? _objectSpread(_objectSpread({}, e), {}, {
          toasts: []
        }) : _objectSpread(_objectSpread({}, e), {}, {
          toasts: e.toasts.filter(r => r.id !== t.toastId)
        });
      case 5:
        return _objectSpread(_objectSpread({}, e), {}, {
          pausedAt: t.time
        });
      case 6:
        let n = t.time - (e.pausedAt || 0);
        return _objectSpread(_objectSpread({}, e), {}, {
          pausedAt: void 0,
          toasts: e.toasts.map(r => _objectSpread(_objectSpread({}, r), {}, {
            pauseDuration: r.pauseDuration + n
          }))
        });
    }
  },
  V = [],
  Z = {
    toasts: [],
    pausedAt: void 0,
    settings: {
      toastLimit: le
    }
  },
  T = {},
  ee = function (e) {
    let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Y;
    T[t] = K(T[t] || Z, e), V.forEach(_ref => {
      let [o, s] = _ref;
      o === t && s(T[t]);
    });
  },
  Q = e => Object.keys(T).forEach(t => ee(e, t)),
  te = e => Object.keys(T).find(t => T[t].toasts.some(o => o.id === e)),
  P = function () {
    let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Y;
    return t => {
      ee(t, e);
    };
  },
  ue = {
    blank: 4e3,
    error: 4e3,
    success: 2e3,
    loading: 1 / 0,
    custom: 4e3
  },
  w = function () {
    let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Y;
    let [o, s] = (0, A.useState)(T[t] || Z),
      a = (0, A.useRef)(T[t]);
    (0, A.useEffect)(() => (a.current !== T[t] && s(T[t]), V.push([t, s]), () => {
      let r = V.findIndex(_ref2 => {
        let [u] = _ref2;
        return u === t;
      });
      r > -1 && V.splice(r, 1);
    }), [t]);
    let n = o.toasts.map(r => {
      var u, x, y;
      return _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, e), e[r.type]), r), {}, {
        removeDelay: r.removeDelay || ((u = e[r.type]) == null ? void 0 : u.removeDelay) || (e == null ? void 0 : e.removeDelay),
        duration: r.duration || ((x = e[r.type]) == null ? void 0 : x.duration) || (e == null ? void 0 : e.duration) || ue[r.type],
        style: _objectSpread(_objectSpread(_objectSpread({}, e.style), (y = e[r.type]) == null ? void 0 : y.style), r.style)
      });
    });
    return _objectSpread(_objectSpread({}, o), {}, {
      toasts: n
    });
  };
var Te = function (e) {
    let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "blank";
    let o = arguments.length > 2 ? arguments[2] : undefined;
    return _objectSpread(_objectSpread({
      createdAt: Date.now(),
      visible: !0,
      dismissed: !1,
      type: t,
      ariaProps: {
        role: "status",
        "aria-live": "polite"
      },
      message: e,
      pauseDuration: 0
    }, o), {}, {
      id: (o == null ? void 0 : o.id) || J()
    });
  },
  D = e => (t, o) => {
    let s = Te(t, e, o);
    return P(s.toasterId || te(s.id))({
      type: 2,
      toast: s
    }), s.id;
  },
  i = (e, t) => D("blank")(e, t);
i.error = D("error");
i.success = D("success");
i.loading = D("loading");
i.custom = D("custom");
i.dismiss = (e, t) => {
  let o = {
    type: 3,
    toastId: e
  };
  t ? P(t)(o) : Q(o);
};
i.dismissAll = e => i.dismiss(void 0, e);
i.remove = (e, t) => {
  let o = {
    type: 4,
    toastId: e
  };
  t ? P(t)(o) : Q(o);
};
i.removeAll = e => i.remove(void 0, e);
i.promise = (e, t, o) => {
  let s = i.loading(t.loading, _objectSpread(_objectSpread({}, o), o == null ? void 0 : o.loading));
  return typeof e == "function" && (e = e()), e.then(a => {
    let n = t.success ? g(t.success, a) : void 0;
    return n ? i.success(n, _objectSpread(_objectSpread({
      id: s
    }, o), o == null ? void 0 : o.success)) : i.dismiss(s), a;
  }).catch(a => {
    let n = t.error ? g(t.error, a) : void 0;
    n ? i.error(n, _objectSpread(_objectSpread({
      id: s
    }, o), o == null ? void 0 : o.error)) : i.dismiss(s);
  }), e;
};
var l = require("react");
var ye = 1e3,
  M = function (e) {
    let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "default";
    let {
        toasts: o,
        pausedAt: s
      } = w(e, t),
      a = (0, l.useRef)(new Map()).current,
      n = (0, l.useCallback)(function (c) {
        let m = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ye;
        if (a.has(c)) return;
        let p = setTimeout(() => {
          a.delete(c), r({
            type: 4,
            toastId: c
          });
        }, m);
        a.set(c, p);
      }, []);
    (0, l.useEffect)(() => {
      if (s) return;
      let c = Date.now(),
        m = o.map(p => {
          if (p.duration === 1 / 0) return;
          let I = (p.duration || 0) + p.pauseDuration - (c - p.createdAt);
          if (I < 0) {
            p.visible && i.dismiss(p.id);
            return;
          }
          return setTimeout(() => i.dismiss(p.id, t), I);
        });
      return () => {
        m.forEach(p => p && clearTimeout(p));
      };
    }, [o, s, t]);
    let r = (0, l.useCallback)(P(t), [t]),
      u = (0, l.useCallback)(() => {
        r({
          type: 5,
          time: Date.now()
        });
      }, [r]),
      x = (0, l.useCallback)((c, m) => {
        r({
          type: 1,
          toast: {
            id: c,
            height: m
          }
        });
      }, [r]),
      y = (0, l.useCallback)(() => {
        s && r({
          type: 6,
          time: Date.now()
        });
      }, [s, r]),
      d = (0, l.useCallback)((c, m) => {
        let {
            reverseOrder: p = !1,
            gutter: I = 8,
            defaultPosition: X
          } = m || {},
          W = o.filter(f => (f.position || X) === (c.position || X) && f.height),
          re = W.findIndex(f => f.id === c.id),
          q = W.filter((f, H) => H < re && f.visible).length;
        return W.filter(f => f.visible).slice(...(p ? [q + 1] : [0, q])).reduce((f, H) => f + (H.height || 0) + I, 0);
      }, [o]);
    return (0, l.useEffect)(() => {
      o.forEach(c => {
        if (c.dismissed) n(c.id, c.removeDelay);else {
          let m = a.get(c.id);
          m && (clearTimeout(m), a.delete(c.id));
        }
      });
    }, [o, n]), {
      toasts: o,
      handlers: {
        updateHeight: x,
        startPause: u,
        endPause: y,
        calculateOffset: d
      }
    };
  };
var h = j(require("react")),
  v = require("goober");
var S = j(require("react")),
  E = require("goober");
var R = require("goober"),
  ge = R.keyframes(_templateObject || (_templateObject = _taggedTemplateLiteral(["\nfrom {\n  transform: scale(0) rotate(45deg);\n\topacity: 0;\n}\nto {\n transform: scale(1) rotate(45deg);\n  opacity: 1;\n}"]))),
  he = R.keyframes(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\nfrom {\n  transform: scale(0);\n  opacity: 0;\n}\nto {\n  transform: scale(1);\n  opacity: 1;\n}"]))),
  xe = R.keyframes(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\nfrom {\n  transform: scale(0) rotate(90deg);\n\topacity: 0;\n}\nto {\n  transform: scale(1) rotate(90deg);\n\topacity: 1;\n}"]))),
  C = (0, R.styled)("div")(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  width: 20px;\n  opacity: 0;\n  height: 20px;\n  border-radius: 10px;\n  background: ", ";\n  position: relative;\n  transform: rotate(45deg);\n\n  animation: ", " 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)\n    forwards;\n  animation-delay: 100ms;\n\n  &:after,\n  &:before {\n    content: '';\n    animation: ", " 0.15s ease-out forwards;\n    animation-delay: 150ms;\n    position: absolute;\n    border-radius: 3px;\n    opacity: 0;\n    background: ", ";\n    bottom: 9px;\n    left: 4px;\n    height: 2px;\n    width: 12px;\n  }\n\n  &:before {\n    animation: ", " 0.15s ease-out forwards;\n    animation-delay: 180ms;\n    transform: rotate(90deg);\n  }\n"])), e => e.primary || "#ff4b4b", ge, he, e => e.secondary || "#fff", xe);
var F = require("goober"),
  be = F.keyframes(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n"]))),
  L = (0, F.styled)("div")(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  width: 12px;\n  height: 12px;\n  box-sizing: border-box;\n  border: 2px solid;\n  border-radius: 100%;\n  border-color: ", ";\n  border-right-color: ", ";\n  animation: ", " 1s linear infinite;\n"])), e => e.secondary || "#e0e0e0", e => e.primary || "#616161", be);
var O = require("goober"),
  Se = O.keyframes(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\nfrom {\n  transform: scale(0) rotate(45deg);\n\topacity: 0;\n}\nto {\n  transform: scale(1) rotate(45deg);\n\topacity: 1;\n}"]))),
  Ae = O.keyframes(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n0% {\n\theight: 0;\n\twidth: 0;\n\topacity: 0;\n}\n40% {\n  height: 0;\n\twidth: 6px;\n\topacity: 1;\n}\n100% {\n  opacity: 1;\n  height: 10px;\n}"]))),
  U = (0, O.styled)("div")(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  width: 20px;\n  opacity: 0;\n  height: 20px;\n  border-radius: 10px;\n  background: ", ";\n  position: relative;\n  transform: rotate(45deg);\n\n  animation: ", " 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)\n    forwards;\n  animation-delay: 100ms;\n  &:after {\n    content: '';\n    box-sizing: border-box;\n    animation: ", " 0.2s ease-out forwards;\n    opacity: 0;\n    animation-delay: 200ms;\n    position: absolute;\n    border-right: 2px solid;\n    border-bottom: 2px solid;\n    border-color: ", ";\n    bottom: 6px;\n    left: 6px;\n    height: 10px;\n    width: 6px;\n  }\n"])), e => e.primary || "#61d345", Se, Ae, e => e.secondary || "#fff");
var Pe = (0, E.styled)("div")(_templateObject0 || (_templateObject0 = _taggedTemplateLiteral(["\n  position: absolute;\n"]))),
  Re = (0, E.styled)("div")(_templateObject1 || (_templateObject1 = _taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-width: 20px;\n  min-height: 20px;\n"]))),
  Ee = E.keyframes(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\nfrom {\n  transform: scale(0.6);\n  opacity: 0.4;\n}\nto {\n  transform: scale(1);\n  opacity: 1;\n}"]))),
  ve = (0, E.styled)("div")(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  position: relative;\n  transform: scale(0.6);\n  opacity: 0.4;\n  min-width: 20px;\n  animation: ", " 0.3s 0.12s cubic-bezier(0.175, 0.885, 0.32, 1.275)\n    forwards;\n"])), Ee),
  $ = _ref3 => {
    let {
      toast: e
    } = _ref3;
    let {
      icon: t,
      type: o,
      iconTheme: s
    } = e;
    return t !== void 0 ? typeof t == "string" ? S.createElement(ve, null, t) : t : o === "blank" ? null : S.createElement(Re, null, S.createElement(L, _objectSpread({}, s)), o !== "loading" && S.createElement(Pe, null, o === "error" ? S.createElement(C, _objectSpread({}, s)) : S.createElement(U, _objectSpread({}, s))));
  };
var De = e => "\n0% {transform: translate3d(0,".concat(e * -200, "%,0) scale(.6); opacity:.5;}\n100% {transform: translate3d(0,0,0) scale(1); opacity:1;}\n"),
  Oe = e => "\n0% {transform: translate3d(0,0,-1px) scale(1); opacity:1;}\n100% {transform: translate3d(0,".concat(e * -150, "%,-1px) scale(.6); opacity:0;}\n"),
  Ie = "0%{opacity:0;} 100%{opacity:1;}",
  ke = "0%{opacity:1;} 100%{opacity:0;}",
  _e = (0, v.styled)("div")(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  background: #fff;\n  color: #363636;\n  line-height: 1.3;\n  will-change: transform;\n  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1), 0 3px 3px rgba(0, 0, 0, 0.05);\n  max-width: 350px;\n  pointer-events: auto;\n  padding: 8px 10px;\n  border-radius: 8px;\n"]))),
  Ve = (0, v.styled)("div")(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  margin: 4px 10px;\n  color: inherit;\n  flex: 1 1 auto;\n  white-space: pre-line;\n"]))),
  we = (e, t) => {
    let s = e.includes("top") ? 1 : -1,
      [a, n] = _() ? [Ie, ke] : [De(s), Oe(s)];
    return {
      animation: t ? "".concat((0, v.keyframes)(a), " 0.35s cubic-bezier(.21,1.02,.73,1) forwards") : "".concat((0, v.keyframes)(n), " 0.4s forwards cubic-bezier(.06,.71,.55,1)")
    };
  },
  N = h.memo(_ref4 => {
    let {
      toast: e,
      position: t,
      style: o,
      children: s
    } = _ref4;
    let a = e.height ? we(e.position || t || "top-center", e.visible) : {
        opacity: 0
      },
      n = h.createElement($, {
        toast: e
      }),
      r = h.createElement(Ve, _objectSpread({}, e.ariaProps), g(e.message, e));
    return h.createElement(_e, {
      className: e.className,
      style: _objectSpread(_objectSpread(_objectSpread({}, a), o), e.style)
    }, typeof s == "function" ? s({
      icon: n,
      message: r
    }) : h.createElement(h.Fragment, null, n, r));
  });
var B = require("goober"),
  b = j(require("react"));
(0, B.setup)(b.createElement);
var Me = _ref5 => {
    let {
      id: e,
      className: t,
      style: o,
      onHeightUpdate: s,
      children: a
    } = _ref5;
    let n = b.useCallback(r => {
      if (r) {
        let u = () => {
          let x = r.getBoundingClientRect().height;
          s(e, x);
        };
        u(), new MutationObserver(u).observe(r, {
          subtree: !0,
          childList: !0,
          characterData: !0
        });
      }
    }, [e, s]);
    return b.createElement("div", {
      ref: n,
      className: t,
      style: o
    }, a);
  },
  Ce = (e, t) => {
    let o = e.includes("top"),
      s = o ? {
        top: 0
      } : {
        bottom: 0
      },
      a = e.includes("center") ? {
        justifyContent: "center"
      } : e.includes("right") ? {
        justifyContent: "flex-end"
      } : {};
    return _objectSpread(_objectSpread({
      left: 0,
      right: 0,
      display: "flex",
      position: "absolute",
      transition: _() ? void 0 : "all 230ms cubic-bezier(.21,1.02,.73,1)",
      transform: "translateY(".concat(t * (o ? 1 : -1), "px)")
    }, s), a);
  },
  Fe = B.css(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n  z-index: 9999;\n  > * {\n    pointer-events: auto;\n  }\n"]))),
  z = 16,
  oe = _ref6 => {
    let {
      reverseOrder: e,
      position: t = "top-center",
      toastOptions: o,
      gutter: s,
      children: a,
      toasterId: n,
      containerStyle: r,
      containerClassName: u
    } = _ref6;
    let {
      toasts: x,
      handlers: y
    } = M(o, n);
    return b.createElement("div", {
      "data-rht-toaster": n || "",
      style: _objectSpread({
        position: "fixed",
        zIndex: 9999,
        top: z,
        left: z,
        right: z,
        bottom: z,
        pointerEvents: "none"
      }, r),
      className: u,
      onMouseEnter: y.startPause,
      onMouseLeave: y.endPause
    }, x.map(d => {
      let c = d.position || t,
        m = y.calculateOffset(d, {
          reverseOrder: e,
          gutter: s,
          defaultPosition: t
        }),
        p = Ce(c, m);
      return b.createElement(Me, {
        id: d.id,
        key: d.id,
        onHeightUpdate: y.updateHeight,
        className: d.visible ? Fe : "",
        style: p
      }, d.type === "custom" ? g(d.message, d) : a ? a(d) : b.createElement(N, {
        toast: d,
        position: c
      }));
    }));
  };
var Le = i;
0 && (module.exports = {
  CheckmarkIcon,
  ErrorIcon,
  LoaderIcon,
  ToastBar,
  ToastIcon,
  Toaster,
  resolveValue,
  toast,
  useToaster,
  useToasterStore
});